
import React from 'react';

import { Link } from 'react-router-dom';

export default class MainPage extends React.Component
{
  render()
  {
    return (
      <div>
        Main Page<br />
        <Link to={"/info"}>info</Link><br />
        <Link to={"/data"}>data</Link><br />
      </div>
    );
  }
}